import { render, staticRenderFns } from "./AccountDeletedModal.vue?vue&type=template&id=30a75f26&scoped=true&"
import script from "./AccountDeletedModal.vue?vue&type=script&lang=ts&"
export * from "./AccountDeletedModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a75f26",
  null
  
)

export default component.exports